<script lang="ts">
import { defineComponent } from "vue";

import { sendButtonCtaTelemetry } from "@/utils/ctaTelemetry";
import isUnauth from "@/utils/isUnauth";

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showFeedback: false,
    };
  },
  methods: {
    isUnauth,
    async showFeedbackModal() {
      await sendButtonCtaTelemetry(
        this.$route.fullPath,
        "Feedback",
        this.isUnauth()
      );
      this.showFeedback = !this.showFeedback;
    },
  },
});
</script>

<template>
  <div>
    <div class="fixed right-0 top-1/2 z-[9999999] h-28 w-28">
      <button
        class="btn -rotate-90 bg-blue-light text-white-lightest"
        @click.prevent="showFeedbackModal"
        @keyup.enter.prevent="showFeedbackModal"
        @keyup.space.prevent="showFeedbackModal"
        data-cy="feedback-btn"
      >
        Feedback
      </button>
    </div>
    <div
      class="fixed bottom-0 left-0 right-0 top-0 z-[9999999] h-screen w-screen bg-black bg-opacity-50"
      v-if="showFeedback"
      @click.prevent="showFeedback = false"
      @keyup.enter.prevent="showFeedback = false"
    >
      <div
        class="mx-auto my-40 flex w-[90%] items-center rounded-xl border border-gray bg-white-lightest p-4"
      >
        <iframe :src="url" width="100%" height="600px" title="survey"></iframe>
      </div>
    </div>
  </div>
</template>
